var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKiemDinhCldt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{fill:#fdbc42;}.cls-3{fill:#18b575;}.cls-4{fill:#ed1869;}.cls-5{fill:#3d55a5;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.12,
    y: 33.3,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ki\\u1EC3m_\\u0111\\u1ECBnh",
    "data-name": "Ki\\u1EC3m \\u0111\\u1ECBnh"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_358_Basic_General_Gear_Wheel",
    "data-name": "358, Basic, General, Gear, Wheel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.13,104.22a21.66,21.66,0,1,1-21.88,21.66A21.84,21.84,0,0,1,125.13,104.22Zm11.68,21.83a11.69,11.69,0,0,0-23.37,0,11.69,11.69,0,1,0,23.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.2,122.08V130a3.79,3.79,0,0,1-3.5,3.8l-6,.34a31.69,31.69,0,0,1-3.68,8.76l4,4.63a3.77,3.77,0,0,1-.17,5.12l-5.67,5.63a3.88,3.88,0,0,1-5.18.16l-4.68-4a32,32,0,0,1-8.84,3.64l-.51,5.95a3.8,3.8,0,0,1-3.84,3.47h-8a3.8,3.8,0,0,1-3.84-3.47l-.5-6.11a32.22,32.22,0,0,1-8.85-3.64l-4.51,4.13a3.89,3.89,0,0,1-5.18-.16l-5.68-5.63a3.77,3.77,0,0,1-.16-5.12l4-4.63a32,32,0,0,1-3.67-8.76l-6.18-.5a3.8,3.8,0,0,1-3.5-3.8v-7.77a3.81,3.81,0,0,1,3.5-3.81l6-.49A31.75,31.75,0,0,1,96.24,109l-4-4.62a3.78,3.78,0,0,1,.17-5.13l5.67-5.62a3.88,3.88,0,0,1,5.18-.17l4.68,4a32.22,32.22,0,0,1,8.85-3.64l.5-6a3.81,3.81,0,0,1,3.84-3.47h8A3.8,3.8,0,0,1,133,87.85l.51,6a32.29,32.29,0,0,1,8.84,3.64l4.68-4a3.89,3.89,0,0,1,5.18.17l5.67,5.62a3.77,3.77,0,0,1,.17,5.13L154,109a31.75,31.75,0,0,1,3.68,8.77l6.18.49A3.8,3.8,0,0,1,167.2,122.08Zm-20.2,4a21.88,21.88,0,1,0-21.87,21.65A21.84,21.84,0,0,0,147,126.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M202.34,126a77,77,0,0,1-22.62,54.6L169,169.79h0a61.95,61.95,0,0,0,0-87.64l10.77-10.77h0A76.93,76.93,0,0,1,202.34,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.72,180.56a77.22,77.22,0,0,1-109.19,0L81.3,169.79a62,62,0,0,0,87.65,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.15,126A61.77,61.77,0,0,0,81.3,169.78h0L70.53,180.56a77.22,77.22,0,0,1,0-109.19L81.3,82.14A61.75,61.75,0,0,0,63.15,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.72,71.37,169,82.14a62,62,0,0,0-87.65,0L70.54,71.37a77.18,77.18,0,0,1,109.18,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiemDinhCldt);
export default __webpack_public_path__ + "static/media/kiem_dinh_cldt.194af5c6bc385af4895b50c01c5e2c8e.svg";
export { ForwardRef as ReactComponent };